export default __webpack_public_path__ + "static/jUSDC-b5cfe8b072afdb1484beaeec04bd61e5.svg";